import * as z from "zod";

export const onboardingV2TimePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

export const onboardingV2CustomRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

const timePeriodInputSchema = z.object({
  timePeriod: onboardingV2TimePeriodSchema,
  customRange: onboardingV2CustomRangeSchema.optional(),
});

type TimePeriodInput = z.infer<typeof timePeriodInputSchema>;

/**
 * Shared `superRefine` callback: when `timePeriod` is "custom", `customRange`
 * must be provided. The ctx type is derived from `superRefine` itself.
 */
export const requireCustomRangeWhenCustom = (
  value: TimePeriodInput,
  ctx: Parameters<
    Parameters<(typeof timePeriodInputSchema)["superRefine"]>[0]
  >[1],
): void => {
  if (value.timePeriod === "custom" && !value.customRange) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "customRange is required when timePeriod is custom",
      path: ["customRange"],
    });
  }
};

export type OnboardingV2TimePeriod = z.infer<
  typeof onboardingV2TimePeriodSchema
>;
export type OnboardingV2CustomRange = z.infer<
  typeof onboardingV2CustomRangeSchema
>;
